import { MenuElement } from "./MenuElement";
import "../../styles/layout.scss";
import logo from "../../assets/logo.svg";

export const Header = () => {
    return (
        <div className="layout__header">
            <img className="layout__header__logo" src={logo} alt="Логотип" />
            <MenuElement />
        </div>
    )
}